export const PROBE_GET_REQUEST = 'PROBE_GET_REQUEST';
export const PROBE_GET_SUCCESS = 'PROBE_GET_SUCCESS';
export const PROBE_GET_ERROR = 'PROBE_GET_ERROR';
export const PROBE_GET_BY_KEY_REQUEST = 'PROBE_GET_BY_KEY_REQUEST';
export const PROBE_GET_BY_KEY_SUCCESS = 'PROBE_GET_BY_KEY_SUCCESS';
export const PROBE_GET_BY_KEY_ERROR = 'PROBE_GET_BY_KEY_ERROR';
export const PROBE_ADD_REQUEST = 'PROBE_ADD_REQUEST';
export const PROBE_ADD_SUCCESS = 'PROBE_ADD_SUCCESS';
export const PROBE_ADD_ERROR = 'PROBE_ADD_ERROR';
export const PROBE_EDIT_REQUEST = 'PROBE_EDIT_REQUEST';
export const PROBE_EDIT_SUCCESS = 'PROBE_EDIT_SUCCESS';
export const PROBE_EDIT_ERROR = 'PROBE_EDIT_ERROR';
export const PROBE_DELETE_REQUEST = 'PROBE_DELETE_REQUEST';
export const PROBE_DELETE_SUCCESS = 'PROBE_DELETE_SUCCESS';
export const PROBE_DELETE_ERROR = 'PROBE_DELETE_ERROR';
